import { home, rvitpage, rvitHome } from '@project/api/rvitpage/v1'
import { about } from '@project/api/about/v1'
import { jobPage } from '@project/api/job-page/v1'
import { paginate as paginateAgendas, total as totalAgendas, page as agendasPage } from '@project/api/agendas/v1'
import { paginate as paginateMinutes, total as totalMinutes, page as minutesPage } from '@project/api/minutes/v1'
import { paginate as paginateNews, total as totalNews, page as newsPage, newsStory } from '@project/api/news/v1'



export default {
  async home() {
    return await home()
  },
  async about() {
    return await about()
  },
  async rvitHome() {
    return await rvitHome()
  },
  async jobPage(slug) {
    const jp = await jobPage(slug)
    return jp
  },
  async rvitEvent(slug) {
    const rp = await rvitpage(slug, 'events')
    return rp
  },
  async rvitProgram(slug) {
    const rp = await rvitpage(slug, 'programs')
    return rp
  },
  async rvitGovernment(slug) {
    const rp = await rvitpage(slug, 'government')
    return rp
  },
  async contactUs() {
    const cU = await rvitpage('contact-us','none')
    return cU
  },
  async rvitProgramDirectory(slug) {
    const rp = await rvitpage(slug, 'program-directory')
    return rp
  },

  //agendas
  async agendas({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateAgendas(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalAgendas() {
    return await totalAgendas()
  },
  async agendasPage() {
    return await agendasPage()
  },


  //minutes
  async minutes({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateMinutes(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalMinutes() {
    return await totalMinutes()
  },
  async minutesPage() {
    return await minutesPage()
  },

  //news
  async news({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateNews(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalNews() {
    return await totalNews()
  },
  async newsPage() {
    return await newsPage()
  },
  async newsStory(urlSlug) {
    return await newsStory(urlSlug)
  },
}

